import { enableSpinner, disableSpinner } from '../spinner';

const DEFAULT_MODALS = {
    error: '/ajax/modals/error/default',
    success: '/ajax/modals/success/default',
};

window.addEventListener('forms.submitting', (e) => {
    const { form } = e.detail;

    const buttons = form.querySelectorAll('button');

    buttons.forEach((el) => {
        el.disabled = true;
        if (el.classList.contains('btn-loading')) {
            enableSpinner(el);
        }
    });

    if (form.dataset.successCallback) {
        window.dispatchEvent(
            new CustomEvent(`forms.submitting.${form.dataset.successCallback}`, {
                detail: {
                    form,
                },
            })
        );
    }
    if (form.dataset.errorCallback) {
        window.dispatchEvent(
            new CustomEvent(`forms.submitting.${form.dataset.errorCallback}`, {
                detail: {
                    form,
                },
            })
        );
    }
});

window.addEventListener('forms.error', async (e) => {
    const { openRemoteModal } = await import('@js/utilities/remoteModal');
    const { form, data } = e.detail;

    const buttons = form.querySelectorAll('button');
    buttons.forEach((el) => {
        el.disabled = false;
        if (el.classList.contains('btn-loading')) {
            disableSpinner(el);
        }
    });

    let customDataJSON = null;

    if (typeof data === 'object' && data !== null) {
        customDataJSON = encodeURIComponent(JSON.stringify(data));
    }

    if (form.dataset.errorCallback) {
        window.dispatchEvent(
            new CustomEvent(`forms.error.${form.dataset.errorCallback}`, {
                detail: e.detail,
            })
        );
    } else if (form.dataset.errorModal) {
        openRemoteModal(form.dataset.errorModal);
    } else {
        openRemoteModal(
            `${DEFAULT_MODALS.error}${customDataJSON ? `?custom_data_json=${customDataJSON}` : ''}`
        );
    }
});

window.addEventListener('forms.success', async (e) => {
    const { openRemoteModal } = await import('@js/utilities/remoteModal');
    const { form } = e.detail;

    const buttons = form.querySelectorAll('button');
    buttons.forEach((el) => {
        el.disabled = false;
        if (el.classList.contains('btn-loading')) {
            disableSpinner(el);
        }
    });

    const modalToCloseInstance = window.bootstrap.Modal.getInstance(form.closest('.modal'));

    if (form.dataset.successCallback) {
        window.dispatchEvent(
            new CustomEvent(`forms.success.${form.dataset.successCallback}`, {
                detail: e.detail,
            })
        );
    } else if (form.dataset.successModal) {
        openRemoteModal(form.dataset.successModal);
        form.reset();
        modalToCloseInstance?.hide();
    } else {
        openRemoteModal(`${DEFAULT_MODALS.success}`);
        form.reset();
        modalToCloseInstance?.hide();
    }
});
